import React, { useState } from "react";
import "./Careerform.css";

function JobApplicationForm() {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    mobile: "",
    experience: "",
    experienceOther: "",
    jobRole: "",
    resume: null,
  });

  const [errors, setErrors] = useState({});

  const handleChange = (e) => {
    const { name, value, files } = e.target;

    if (name === "name") {
      let val = value
        .replace(/[^a-zA-Z ]/g, "")
        .replace(/\s+/g, " ")
        .trimStart();
      if (val.length > 100) val = val.slice(0, 100);
      setFormData({ ...formData, name: val });
      return;
    }

    if (name === "mobile") {
      let val = value.replace(/[^0-9]/g, "");
      if (val.length > 10) val = val.slice(0, 10);
      setFormData({ ...formData, mobile: val });
      return;
    }

    if (name === "resume") {
      setFormData({ ...formData, resume: files[0] });
      return;
    }

    setFormData({ ...formData, [name]: value });
  };

  const validate = () => {
    let newErrors = {};

    if (!formData.name) newErrors.name = "!Name is required";
    else if (!/^[A-Z][a-z]*(\s[A-Z][a-z]*)*$/.test(formData.name))
      newErrors.name = "!Each word must start with capital letter";

    if (!formData.email) newErrors.email = "!Email is required";
    else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email))
      newErrors.email = "!Invalid email format";

    if (!formData.mobile) newErrors.mobile = "!Mobile number is required";
    else if (formData.mobile.length < 10)
      newErrors.mobile = "!Mobile number must be 10 digits";

    if (!formData.experience)
      newErrors.experience = "!Experience is required";

    if (
      formData.experience === "Other" &&
      !formData.experienceOther
    ) {
      newErrors.experienceOther = "!Please enter experience";
    }

    if (!formData.jobRole)
      newErrors.jobRole = "!Please select job role";

    if (!formData.resume)
      newErrors.resume = "!Resume is required";
    else if (formData.resume.type !== "application/pdf")
      newErrors.resume = "!Only PDF file allowed";

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!validate()) return;

    const finalExperience =
      formData.experience === "Other"
        ? formData.experienceOther
        : formData.experience;

    alert(
      `🎉 Application Submitted!\nExperience: ${finalExperience}`
    );

    setFormData({
      name: "",
      email: "",
      mobile: "",
      experience: "",
      experienceOther: "",
      jobRole: "",
      resume: null,
    });

    setErrors({});
    e.target.reset();
  };

  return (
    <div className="career-page">
      <div className="job-form">
        <h1>Job Application Form</h1>
        <p className="subtitle">Apply for your desired job position</p>

        <form onSubmit={handleSubmit} noValidate>
          {/* Name */}
          <div className="form-group">
            <label>Full Name</label>
            <input
              type="text"
              name="name"
              value={formData.name}
              onChange={handleChange}
              placeholder="John Doe"
            />
            {errors.name && <small className="error">{errors.name}</small>}
          </div>

          {/* Email */}
          <div className="form-group">
            <label>Email Address</label>
            <input
              type="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              placeholder="example@email.com"
            />
            {errors.email && <small className="error">{errors.email}</small>}
          </div>

          {/* Mobile */}
          <div className="form-group">
            <label>Mobile Number</label>
            <input
              type="text"
              name="mobile"
              value={formData.mobile}
              onChange={handleChange}
              placeholder="10 digit number"
            />
            {errors.mobile && <small className="error">{errors.mobile}</small>}
          </div>

          {/* Experience Dropdown */}
          <div className="form-group">
            <label>Total Experience</label>
            <select
              name="experience"
              value={formData.experience}
              onChange={handleChange}
            >
              <option value="">Select Experience</option>
              <option>Fresher</option>
              <option>1–2 Years</option>
              <option>2–5 Years</option>
              <option>5–10 Years</option>
              <option>10–15 Years</option>
              <option>Other</option>
            </select>
            {errors.experience && (
              <small className="error">{errors.experience}</small>
            )}
          </div>

          {/* Other Experience Input */}
          {formData.experience === "Other" && (
            <div className="form-group">
              <label>Enter Experience</label>
              <input
                type="text"
                name="experienceOther"
                value={formData.experienceOther}
                onChange={handleChange}
                placeholder="e.g. 18 Years / Internship"
              />
              {errors.experienceOther && (
                <small className="error">{errors.experienceOther}</small>
              )}
            </div>
          )}

          {/* Job Role */}
          <div className="form-group">
            <label>Job Role</label>
            <select
              name="jobRole"
              value={formData.jobRole}
              onChange={handleChange}
            >
              <option value="">Select Job Role</option>
              <option>Senior React Developer</option>
              <option>Python Backend Developer</option>
              <option>Java Full Stack Developer</option>
              <option>Web Developer</option>
              <option>.NET Developer</option>
              <option>UI/UX Designer</option>
              <option>DevOps Engineer</option>
              <option>QA Automation Engineer</option>
            </select>
            {errors.jobRole && (
              <small className="error">{errors.jobRole}</small>
            )}
          </div>

          {/* Resume */}
          <div className="form-group">
            <label>Upload Resume (PDF)</label>
            <input
              type="file"
              name="resume"
              accept=".pdf"
              onChange={handleChange}
            />
            {errors.resume && <small className="error">{errors.resume}</small>}
          </div>

          <button type="submit">Apply for Job</button>
        </form>
      </div>
    </div>
  );
}

export default JobApplicationForm;
